import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Text.scss'

const Text = ({ as, type, children, style, html, nowrap, center, className, e2e }) => {
  const Tag = as

  return (
    <Tag
      className={classNames(styles.base, `ft-${type}`, className, {
        [styles.nowrap]: nowrap,
        [styles.center]: center,
      })}
      style={style}
      data-e2e={e2e}
    >
      {html && <span dangerouslySetInnerHTML={{ __html: children }} />}
      {!html && <span>{children}</span>}
    </Tag>
  )
}

Text.defaultProps = {
  as: 'span',
  children: null,
  html: false,
  type: 'default',
  style: {},
  center: false,
  nowrap: false,
  e2e: '',
}
Text.propTypes = {
  as: PropTypes.oneOf(['span', 'div', 'h1', 'h2', 'h3', 'h4']),
  children: PropTypes.node,
  html: PropTypes.bool,
  type: PropTypes.string,
  style: PropTypes.shape(),
}

export default Text
